/* Pivot : message sous le bouton Check Out, seulement si le panier contient une precommande avec une date d'expedition (propriete STOQ "Shipping") */
(function () {
  var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var logged = window.PivotCustomerLoggedIn === true;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function message(dates) {
    var d = '<strong>' + dates.map(esc).join(' · ') + '</strong>';
    if (isFr) {
      return logged
        ? 'Expédition prévue de votre précommande : ' + d + '. Vous pourrez la suivre dans <a href="/account">votre compte</a>.'
        : 'Expédition prévue de votre précommande : ' + d + '. <a href="/account/login">Connectez-vous</a> pour la suivre dans votre compte.';
    }
    return logged
      ? 'Preorder estimated shipping: ' + d + '. You can track it in <a href="/account">your account</a>.'
      : 'Preorder estimated shipping: ' + d + '. <a href="/account/login">Sign in</a> to track it from your account.';
  }

  var busy = false;
  function render() {
    var buttons = document.querySelectorAll('button[name="checkout"]');
    if (!buttons.length || busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dates = [];
        (cart.items || []).forEach(function (it) {
          var s = it.properties && it.properties.Shipping;
          if (s && String(s).trim() && dates.indexOf(String(s).trim()) < 0) dates.push(String(s).trim());
        });
        document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
          var next = btn.nextElementSibling;
          var note = next && next.classList.contains('pv-preorder-note') ? next : null;
          if (!dates.length) { if (note) note.remove(); return; }
          var html = message(dates);
          if (!note) {
            note = document.createElement('p');
            note.className = 'pv-preorder-note';
            btn.insertAdjacentElement('afterend', note);
          }
          if (note.getAttribute('data-html') !== html) {
            note.innerHTML = html;
            note.setAttribute('data-html', html);
          }
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 400); }

  function isOwn(node) {
    return node && node.nodeType === 1 && (node.classList.contains('pv-preorder-note') || node.closest('.pv-preorder-note'));
  }

  function init() {
    render();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (isOwn(r.target)) continue;
        var own = true;
        r.addedNodes.forEach(function (n) { if (!isOwn(n)) own = false; });
        r.removedNodes.forEach(function (n) { if (!isOwn(n)) own = false; });
        if (r.addedNodes.length + r.removedNodes.length === 0) own = false;
        if (!own) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
